export enum DocumentExtensions {
  Pdf = 'pdf',
  Docs = 'docs',
  Png = 'png',
  Jpeg = 'jpeg',
  Jpg = 'jpg',
}
